import * as ScrollAreaPrimitive from '@radix-ui/react-scroll-area'
import { styled } from '../../../lib/stitches'

const SCROLLBAR_SIZE = 10

const StyledScrollArea = styled(ScrollAreaPrimitive.Root, {
  flex: 1,
  overflow: 'hidden'
})

const StyledViewport = styled(ScrollAreaPrimitive.Viewport, {
  maxWidth: '100%',
  height: '100%',
  paddingRight: '16px',
  '> div[style]': {
    display: 'block !important'
  }
})

const StyledScrollbar = styled(ScrollAreaPrimitive.Scrollbar, {
  display: 'flex',
  // ensures no selection
  userSelect: 'none',
  // disable browser handling of all panning and zooming gestures on touch devices
  touchAction: 'none',
  padding: 2,
  background: 'rgba(0,0,0,.05)',
  transition: 'background 160ms ease-out',
  '&:hover': { background: 'rgba(0,0,0,.1)' },
  '&[data-orientation="vertical"]': { width: SCROLLBAR_SIZE },
  '&[data-orientation="horizontal"]': {
    flexDirection: 'column',
    height: SCROLLBAR_SIZE
  }
})

const StyledThumb = styled(ScrollAreaPrimitive.Thumb, {
  flex: 1,
  background: 'rgba(0,0,0,.1)',
  borderRadius: SCROLLBAR_SIZE,
  // increase target size for touch devices https://www.w3.org/WAI/WCAG21/Understanding/target-size.html
  position: 'relative',
  '&::before': {
    content: '""',
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '100%',
    height: '100%',
    minWidth: 44,
    minHeight: 44
  }
})

const StyledCorner = styled(ScrollAreaPrimitive.Corner, {
  background: 'rgba(0,0,0,.05)'
})

// Exports
const ScrollArea = StyledScrollArea
const ScrollAreaViewport = StyledViewport
const ScrollAreaScrollbar = StyledScrollbar
const ScrollAreaThumb = StyledThumb
const ScrollAreaCorner = StyledCorner

export { ScrollArea, ScrollAreaViewport, ScrollAreaScrollbar, ScrollAreaThumb, ScrollAreaCorner }
